import store from '@/store/store';

export default {
  path: 'leaderboard',
  name: 'app-view-leaderboard',
  component: () => import('@/views/app/view_leaderboard/ViewLeaderboard.vue'),
  meta: {
    pageTitle: ''
  },
  beforeEnter: async (to, from, next) => {
    to.meta.pageTitle = 'dashboard.block.leaderboard.title';
    const leaderboardResource = await store.state.router.privateRoot.$request().$get('leaderboard');
    store.commit('router/updateRouteProp', {
      property: 'leaderboardResource',
      value: leaderboardResource
    });
    next();
  },
  props: () => ({
    leaderboardResource: store.state.router.leaderboardResource
  })
};
